import {css} from "styled-components"
import {ButtonCssProps} from "./index"

import {h4, h6} from "../../Typography/Heading/styles"

export const largeCss = css<ButtonCssProps>`
  ${({theme}) => css`
    ${h4};
    padding: ${theme.spacing.two} ${theme.spacing.four};
  `}
`

export const smallCss = css<ButtonCssProps>`
  ${({theme}) => css`
    ${h6};
    padding: ${theme.spacing.one} ${theme.spacing.three};
  `}
`
